import React, { useEffect, useState } from "react";
import "../Delete/DeleteGroup.css";
import "../AddMemeber/AddMemeber.css";
import axios from "../../axios";
import { MultiSelect } from "react-multi-select-component";

export default function AddMemebers({ setAdd, list, setMessage }) {
  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [mem, setMembers] = useState([]);
  let timeTableSessionId = JSON.parse(localStorage.getItem('timeTableSessionId'));
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!timeTableSessionId) {
          return;
        }
        const groupResponse = await axios.get(
          `api/v1/group/getById/${list?.id}?isFullFledged=true`
        );
        const members = groupResponse.data.data.member;
        setMembers(members);

        const studentResponse = await axios.get(
          `/api/v1/school/student/getList?standardId=${list.standard.id}&sectionId=${list.section.id}&timetableSession=${timeTableSessionId}`
        );

        const studentList = studentResponse.data.data
          .filter(student => !members.some(member => member.member?.id === student?.id))
          .map(student => ({ value: student?.id, label: student.name }));
        console.log(studentResponse.data.data.length);
        console.log(members)
        console.log(studentList.length)
        setStudentList(studentList);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [list?.id, list.standard.id, list.section.id]);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  async function cancle() {
    let students_id = [];
    for (const student of selectedList) {
      students_id.push(student.value);
    }
    try {
      const res = await axios.post(`/api/v1/group/addMember/${list.id}`, {
        teacher_id: teacher_id,
        members: {
          students: students_id,
        },
      });
      res && setMessage(true);
      res && setAdd(false);;
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="AddMember_container">
      <div className="AddMember_Subcontainer  col-md-6 col-11">
        <div className="ml-2 mr-1">
          <div className=" addMemeberheding ml-0">Add More Members</div>
          <div className=" col-md-12 col-12 ">
            <MultiSelect
              options={studentList}
              value={selectedList}
              onChange={handleStudentSelection}
              labelledBy="Select"
              overrideStrings={{
                selectSomeItems: "Select Students"
              }}
              className="my-multi-select w-100"
            />
          </div>
          <div className="Add_btn_member_all">
            <button disabled={selectedList.length <= 0} onClick={cancle} className="Add_btn_member col-md-2 col-12">
              Add
            </button>
          </div>
        </div>
      </div>

      <img
        src="/group-img/CrossIconGroup.svg"
        className="delet_icon_For_g"
        alt="cross icon"
        onClick={(e) => {
          setAdd(false);
        }}
      />
    </div>
  );
}
